import { toNumDE } from 'src/app/shared/utils/to-num-de';
import { DossierShellMetricProfile } from '../create-dossier-states-definition';
import { KPI_NAME_KEY } from '../../../../dashboard-config/kpis/kpi-data-transformers';
import {
  DossierMetricProfile,
  dossierEconomicParticipantProfile,
  dossierEmployedProfile,
  dossierGvaProfile,
  dossierRevenueProfile,
  dossierTaxedProfile,
} from '../dossier-metric.profile';
import { DashboardDossierStatesOnionViewConfig } from './dashboard-dossier-states-onion.definition';

/**
 * Onion-shell metric profile: shared dossier metric core +
 * onion view.
 */
export type DossierOnionMetricProfile = DossierShellMetricProfile<
  DashboardDossierStatesOnionViewConfig
>;

function fromShared(
  shared: DossierMetricProfile,
  shell: {
    view: DashboardDossierStatesOnionViewConfig;
  },
): DossierOnionMetricProfile {
  return {
    ...shared,
    ...shell,
  };
}

export const dossierOnionTaxedProfile: DossierOnionMetricProfile =
  fromShared(dossierTaxedProfile, {
    view: {
      valueLabel: (data) => data[0]?.[KPI_NAME_KEY],
    },
  });

export const dossierOnionRevenueProfile: DossierOnionMetricProfile =
  fromShared(dossierRevenueProfile, {
    view: {
      valueLabel: () => 'EUR Gesamtumsatz',
      valueFormatter: (d: any) =>
        toNumDE(d['value']) === '*' ? '*' : toNumDE(+d['value'] * 1000),
    },
  });

export const dossierOnionGvaProfile: DossierOnionMetricProfile =
  fromShared(dossierGvaProfile, {
    view: {
      valueLabel: (data) =>
        `EUR ${data[0]?.[dossierGvaProfile.valueLabelKey] ?? dossierGvaProfile.base.labels.shortLabel}`,
      valueFormatter: (d: any) =>
        toNumDE(d['value']) === '*' ? '*' : toNumDE(+d['value'] * 1000),
    },
  });

export const dossierOnionEconomicParticipantProfile: DossierOnionMetricProfile =
  fromShared(dossierEconomicParticipantProfile, {
    view: {
      valueLabel: (data) => data[0]?.[KPI_NAME_KEY],
    },
  });

export const dossierOnionEmployedProfile: DossierOnionMetricProfile =
  fromShared(dossierEmployedProfile, {
    view: {
      valueLabel: (data) => data[0]?.[KPI_NAME_KEY],
    },
  });
